import { useTranslation } from '../../lib/i18n';
import { drawnUsageWindows, usageWindowMeter } from '../../lib/usageMeter';
import { RailList, RailMeter } from '../../components/ui/RailPrimitives';
import type { ProviderUsage } from '../../lib/types';

/** An account's usage windows (subscription 5h/weekly, or an API account's balance, key limit and free-model
 *  allowance), one pressure-coloured `RailMeter` per window; `usageWindowMeter` decides the label, figure and
 *  hover hint. The ONE markup for these rows: a connected OAuth row in Settings (`flush`, no rail lead
 *  column) and the chat telemetry rail's Limits section both render it, over `drawnUsageWindows`. Renders
 *  nothing when the account reports no windows. */
export function OAuthUsageRail({ usage, flush = false }: { usage: ProviderUsage; flush?: boolean }) {
  const { t, locale } = useTranslation();
  const windows = drawnUsageWindows(usage.windows);
  if (!windows.length) return null;
  return (
    <RailList flush={flush}>
      {windows.map((w, i) => {
        const meter = usageWindowMeter(w, t, locale);
        return (
          <RailMeter
            key={`${w.kind ?? 'time'}-${w.windowMinutes ?? 'window'}-${i}`}
            testId="oauth-usage-window"
            label={meter.label}
            percent={w.usedPercent}
            value={meter.value}
            tone="pressure"
            flush={flush}
            title={meter.title}
          />
        );
      })}
    </RailList>
  );
}
